module.exports = __webpack_public_path__ + "images/emoji/computer.926497aeb38ba7e4c55d.png";